import type { TenantSummary, UserSummary } from '@forq/contracts';

export const foundationTenants: readonly TenantSummary[] = [
  { id: 'ftw', name: 'Fördertechnik Werl GmbH', shortName: 'FTW', numberPrefix: '1' },
  { id: 'stw', name: 'Spezialtransporte Werl', shortName: 'STW', numberPrefix: '2' },
  { id: 'gsl', name: 'Gabelstapler Sauerland GmbH', shortName: 'GSL', numberPrefix: '3' },
];

export const foundationUser: UserSummary = {
  id: 'foundation-user',
  displayName: 'Frederick',
  role: 'Administrator',
};

export const foundationPermissions = new Set<string>([
  'preview.complete.view',
  'dashboard.view',
  'dashboard.kpis.view',
  'dashboard.tasks.view',
  'dashboard.quick-actions.view',
  'dashboard.architecture.view',
  'studio.runtime.configure',
  'customers.view',
  'customers.create',
  'customers.edit',
  'customers.delete',
  'customers.contacts.manage',
  'machines.view',
  'machines.create',
  'machines.edit',
  'machines.delete',
  'machines.types.manage',
  'masterdata.view',
  'masterdata.articles.view',
  'masterdata.articles.manage',
  // Die vier .delete-Rechte stehen im echten Seed (20260717150000_record_delete.sql), fehlten
  // aber hier -- dadurch war der Löschknopf in Artikel/Lieferanten/Angebote/Vorgänge im
  // Demo-Modus deaktiviert (dieselbe Falle wie bei admin.tenants.manage).
  'masterdata.articles.delete',
  'masterdata.services.view',
  'masterdata.services.manage',
  'masterdata.suppliers.view',
  'masterdata.suppliers.manage',
  'masterdata.suppliers.delete',
  'masterdata.purchase_prices.view',
  'warehouse.view',
  'warehouse.stock.view',
  'warehouse.movements.view',
  'warehouse.movements.post',
  'warehouse.locations.view',
  'warehouse.locations.manage',
  'warehouse.locations.delete',
  'warehouse.replenishment.view',
  'warehouse.negative_stock.allow',
  'sales.view',
  'sales.pipeline.view',
  'sales.opportunities.manage',
  'sales.offers.view',
  'sales.offers.manage',
  'sales.offers.delete',
  'sales.decisions.manage',
  'sales.orders.view',
  'sales.handoffs.view',
  'sales.margin.view',
  'orders.view',
  'orders.create',
  'orders.edit',
  'orders.assign',
  'orders.complete',
  'orders.delete',
  'orders.send_to_billing',
  'service.view',
  'service.plan',
  'service.print',
  'service.return.capture',
  'service.approval.manage',
  'service.transition',
  'technician.view',
  'rental.view',
  'rental.edit',
  'rental.dispatch',
  'rental.return',
  'rental.bill',
  'purchasing.view',
  'logistics.view',
  'documents.view',
  'finance.view',
  'finance.invoices.edit',
  'finance.invoices.approve',
  'finance.invoices.issue',
  'finance.invoices.send',
  'finance.invoices.cancel',
  'finance.payments.record',
  'finance.payments.approve',
  'finance.incoming.capture',
  'finance.incoming.edit',
  'finance.incoming.review',
  'messenger.view',
  'feedback.view',
  'forqy.view',
  'admin.view',
  // Steht im echten Seed (20260717100000_seed_reference_data.sql) und schuetzt dort
  // Mandanteneinstellungen und Systemmeldungen. Fehlte hier, obwohl der Demo-Benutzer sonst
  // ueberall 'manage' hat -- dadurch war die Systemmeldungs-Pflege im Demo-Modus unsichtbar.
  'admin.tenants.manage',
  'admin.users.view',
  'admin.users.manage',
  'admin.roles.view',
  'admin.roles.manage',
  'admin.numbering.view',
  'admin.numbering.manage',
  'admin.audit.view',
]);
